import { fmt, fmtMoney, fmtDate, logoUrl } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";

export const CreditNote = ({ sale, ret }) => {
  const { logoV, settings } = useSettings();
  return (
    <div id="receipt" className="mx-auto w-full max-w-[300px] bg-white p-4 font-mono text-[12px] leading-tight text-black" data-testid="credit-note">
      <div className="text-center">
        {logoV && <img src={logoUrl(logoV)} alt="logo" className="mx-auto mb-1 max-h-16 object-contain" />}
        <p className="text-base font-bold uppercase">{settings.company_name}</p>{settings.address && <p>{settings.address}</p>}
        <p>{sale.warehouse_name}</p>
        {settings.phone && <p>Tél : {settings.phone}</p>}
        <p className="my-1">--------------------------------</p>
        <p className="text-sm font-bold">TICKET D'AVOIR</p>
        <p className="font-bold" data-testid="credit-note-number">{ret.number || "—"}</p>
        <p>{fmtDate(ret.created_at)}</p>
        <p>Vente d'origine : {sale.number}</p>
        <p>Par : {ret.user_name}</p>
        {sale.customer_name && <p>Client : {sale.customer_name} {sale.customer_phone}</p>}
        <p className="my-1">--------------------------------</p>
      </div>
      {ret.lines.map((l, i) => (
        <div key={i} className="mb-1">
          <p className="font-semibold">{l.fabric_name}</p>
          <div className="flex justify-between"><span>{fmt(l.quantity)} {l.sale_unit === "rouleau" ? "rlx" : l.unit || "m"}{l.unit_price != null ? ` x ${fmtMoney(l.unit_price)}` : ""}</span><span>{l.total != null ? fmtMoney(l.total) : ""}</span></div>
        </div>
      ))}
      <p className="my-1 text-center">--------------------------------</p>
      <div className="flex justify-between text-base font-bold"><span>REMBOURSÉ</span><span data-testid="credit-note-amount">{fmtMoney(ret.amount)} {settings.currency}</span></div>
      <p className="mt-1">Motif : {ret.reason || "—"}</p>
      <p>{ret.full ? "Annulation totale de la vente" : "Retour partiel"}</p>
      <p className="my-1 text-center">--------------------------------</p>
      <p className="text-center">Stock remis en dépôt</p>
      <p className="mt-2 text-center text-[10px]">{settings.footer}</p>
    </div>
  );
};
